/** The neutral PMREM studio is a cutscene material aid, not a global gameplay light source. */
export function shouldUseDioramaEnvironment(sceneName: string): boolean {
  return sceneName === 'CutsceneDioramaScene'
}
